<template>
  <div class="modal fade" id="disclaimer-modal-input" role="dialog">
    <div class="modal-dialog modal-md">
      <!-- Modal content-->
      <div class="modal-content bsz">
        <div class="modal-body">
          <div class="terms-wrapper">
            <button type="button" class="btn btn-default btn-back" data-dismiss="modal">
              <i class="ic-back"></i>
            </button>
            <div class="container-fluid">
              <div class="row">
                <div class="col-sm-12">
                  <h3 class="text-center">
                    <strong>DISCLAIMER</strong>
                  </h3>

                  <h4>Acceptance of terms through use please read</h4>
                  <p>
                    This web site is an electronic news and information service of
                    {{ brands }}. You may print and keep a copy of this Agreement. By using
                    this site, you signify your agreement to all terms, conditions, and
                    notices contained or referenced herein (the "Terms of Use"). It is
                    your responsibility to access this document whenever you visit this
                    web site to determine if there have been any changes to the terms of
                    the Terms of Use. If you do not agree to these Terms of Use please do
                    not access or use this site. We reserve the right, at our discretion,
                    to update or revise these Terms and Conditions of Use at any time.
                    Please check the Terms periodically for changes. Your continued use of
                    this site following the posting of any changes to the Terms of Use
                    constitutes acceptance of those changes.
                  </p>

                  <h4>Copyright</h4>
                  <p>
                    All content included on this site, such as text, graphics, logos,
                    button icons, images, and audio clips, digital downloads, data
                    compilations, and software, is the property of {{ brands }} or its
                    content suppliers and protected by Singapore and international
                    copyright laws. The compilation of all content on this site is the
                    exclusive property of {{ brands }} and protected by Singapore and
                    international copyright laws. All software used on this site is the
                    property of {{ brands }} or its software suppliers and protected by
                    Singapore and international copyright laws.
                  </p>

                  <h4>Trademark</h4>
                  <p>
                    {{ brands }} is a registered trademark of City DMC Pte Ltd in Singapore
                    and other countries. {{ brands }} trademark and trade dress may not be
                    used in connection with any product or service that is likely to cause
                    confusion among customers, or in any manner that disparages or
                    discredits {{ brands }}. All other trademarks not owned by {{ brands }} or
                    its subsidiaries that appear on this site are the property of their
                    respective owners, who may or may not be affiliated with, connected
                    to, or sponsored by {{ brands }} or its subsidiaries.
                  </p>

                  <h4>Proprietary rights</h4>
                  <p>
                    You acknowledge and agree that all content and materials available on
                    this site are protected by copyrights, trademarks, service marks,
                    patents, trade secrets, or other proprietary rights and laws. Except
                    as expressly authorized by {{ brands }}, you agree not to sell, license,
                    rent, modify, distribute, copy, reproduce, transmit, publicly display,
                    publicly perform, publish, adapt, edit, or create derivative works
                    from such materials or content. Notwithstanding the above, you may
                    print or download one copy of the materials or content on this site on
                    any single computer for your personal, non-commercial use, provided
                    you keep intact all copyright and other proprietary notices.
                    Systematic retrieval of data or other content from this site to create
                    or compile, directly or indirectly, a collection, compilation,
                    database or directory without written permission from {{ brands }} is
                    prohibited. In addition, use of the content or materials for any
                    purpose not expressly permitted in these Terms of Use is prohibited.
                  </p>
                  <p>
                    As noted above, reproduction, copying, or redistribution for
                    commercial purposes of any materials or design elements on this site
                    is strictly prohibited without the express written permission of
                    {{ brands }}.
                  </p>

                  <h4>User’s grant of limited license</h4>
                  <p>
                    By posting or submitting content to this site, you: a) {{ brands }} and
                    its affiliates and licensees the right to use (in whole or part),
                    reproduce, display, perform, edit, publish, translate, create
                    derivative works from, adapt, modify, distribute, have distributed,
                    and promote the content in any form, anywhere and for any purpose; and
                    b) warrant and represent that you own or otherwise control all of the
                    rights to the content and that public posting and use of your content
                    by {{ brands }} will not infringe or violate the rights of any third
                    party. You also warrant that any «moral rights» in your material have
                    been waived.
                  </p>

                  <h4>Disclaimer of warranties</h4>
                  <p class="uppercase">
                    ALL MATERIALS, INFORMATION, SOFTWARE, PRODUCTS, AND SERVICES INCLUDED
                    IN OR AVAILABLE THROUGH THIS SITE (THE "CONTENT") ARE PROVIDED "AS IS"
                    AND "AS AVAILABLE" FOR YOUR USE. THE SITE, INCLUDING, WITHOUT
                    LIMITATION, ALL CONTENT, FUNCTIONS AND MATERIALS THEREON, IS PROVIDED
                    "AS IS," WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESS OR IMPLIED,
                    INCLUDING, WITHOUT LIMITATION, ANY WARRANTY FOR INFORMATION, DATA,
                    DATA PROCESSING SERVICES, OR UNINTERRUPTED ACCESS, ANY WARRANTIES
                    CONCERNING THE AVAILABILITY, ACCURACY, USEFULNESS, OR CONTENT OF
                    INFORMATION, AND ANY WARRANTIES OF TITLE, NON-INFRINGEMENT,
                    MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE. {{ brands }} DOES
                    NOT WARRANT THAT THE SITE OR THE FUNCTIONS, FEATURES OR CONTENT
                    CONTAINED THEREIN WILL BE TIMELY, SECURE, UNINTERRUPTED OR ERROR FREE,
                    OR THAT DEFECTS WILL BE CORRECTED. {{ brands }} MAKES NO WARRANTY THAT
                    THE SITE WILL MEET USERS' REQUIREMENTS. NO ADVICE, RESULTS OR
                    INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY YOU FROM {{ brands }}
                    OR THROUGH THE SITE SHALL CREATE ANY WARRANTY NOT EXPRESSLY MADE
                    HEREIN. IF YOU ARE DISSATISFIED WITH THE SITE OR ANY CONTENT OR
                    FUNCTION THEREON, YOUR SOLE REMEDY IS TO DISCONTINUE USING THE SITE.
                  </p>

                  <h4>Limitation of liabilities</h4>
                  <p class="uppercase">
                    UNDER NO CIRCUMSTANCES SHALL {{ brands }} OR ANY OF ITS DIRECTORS,
                    OFFICERS, EMPLOYEES, AGENTS, AFFILIATES, SUBSIDIARIES OR ITS LICENSORS
                    BE LIABLE FOR ANY DIRECT, INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, OR
                    CONSEQUENTIAL DAMAGES THAT RESULT FROM THE USE OF OR INABILITY TO USE,
                    THIS SITE. THIS LIMITATION APPLIES WHETHER THE ALLEGED LIABILITY IS
                    BASED ON CONTRACT, TORT, NEGLIGENCE AND STRICT LIABILITY, INCLUDING,
                    WITHOUT LIMITATION, LOSS OF REVENUE, OR ANTICIPATED PROFITS OR LOST
                    BUSINESS OR LOST SALES, EVEN IF {{ brands }} HAS BEEN ADVISED OF THE
                    POSSIBILITY OF SUCH DAMAGE. BECAUSE SOME JURISDICTIONS DO NOT ALLOW
                    THE EXCLUSION OR LIMITATION OF INCIDENTAL OR CONSEQUENTIAL DAMAGES,
                    {{ brands }}’S LIABILITY IN SUCH JURISDICTIONS SHALL BE LIMITED TO THE
                    EXTENT PERMITTED BY LAW.
                  </p>

                  <h4>Indemnification</h4>
                  <p>
                    Upon a request by {{ brands }}, you agree to defend, indemnify, and hold
                    harmless {{ brands }} and its subsidiary and other affiliated companies,
                    and their employees, contractors, officers, and directors from all
                    liabilities, claims, and expenses, including attorney's fees that
                    arise from your use or misuse of this site. {{ brands }} reserves the
                    right, at its own expense, to assume the exclusive defense and control
                    of any matter otherwise subject to indemnification by you, in which
                    event you will cooperate with {{ brands }} in asserting any available
                    defenses.
                  </p>

                  <h4>International use</h4>
                  <p>
                    {{ brands }} makes no representation that materials on this site are
                    appropriate or available for use in locations outside Singapore, and
                    accessing them from territories where their contents are illegal is
                    prohibited. Those who choose to access this site from other locations
                    do so on their own initiative and are responsible for compliance with
                    local laws.
                  </p>

                  <h4>Internet access</h4>
                  <p>
                    You acknowledge and agree that in connection with your use of the Site
                    you must: (a) provide for your own access to the World Wide Web and
                    pay any service fees associated with such access, and (b) provide all
                    equipment necessary for you to make such access and connection to the
                    World Wide Web, including a computer, software, a modem and a means of
                    connecting to or accessing the Internet. {{ brands }} shall not be
                    responsible for any malfunctions, errors, crashes or other adverse
                    events that may occur from your use of the Site.
                  </p>

                  <h4>Third party sites</h4>
                  <p>
                    This site may produce automated search results or otherwise link you
                    to other sites on the Internet. These sites may contain information or
                    material that some people may find inappropriate or offensive. These
                    other sites are not under the control of {{ brands }}, and you
                    acknowledge that {{ brands }} is not responsible or liable directly or
                    indirectly for the accuracy, copyright compliance, legality, decency,
                    or any other aspect of the content of such sites. The inclusion of
                    such a link does not imply endorsement of the site by {{ brands }} or any
                    association with its operators.
                  </p>

                  <h4>Unsolicited Material</h4>
                  <p>
                    Unless specifically requested, {{ brands }} does not solicit nor does it
                    wish to receive any confidential, secret or proprietary information or
                    other material from you through the Site, any of its services, by
                    e-mail, or in any other way.
                  </p>

                  <h4>Choice of law</h4>
                  <p>
                    We control and operate this Site from our offices in Indonesia. Your
                    use of this web site and all related rights and obligations, shall be
                    governed by the Singapore laws. Any legal action or proceeding with
                    respect to this web site, related to these Terms and Conditions of use
                    or any matter related thereto may be brought exclusively in the courts
                    of Singapore. By using this web site, you expressly agree and accept
                    generally and unconditionally the jurisdiction of the aforesaid courts
                    and irrevocably waive any objection to such jurisdiction.
                  </p>

                  <h4>Termination</h4>
                  <p>
                    {{ brands }} reserves the right, in its sole discretion, to terminate
                    your access to all or part of this site, with or without notice.
                  </p>

                  <h5>&copy;{{ thisYear }} {{ brands }}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    thisYear: function () {
      return new Date().getFullYear();
    },
    brands: function () {
      return process.env.BRAND_NAME.toUpperCase();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/shared/Disclaimer.vue